import React from 'react'

interface InputGroupProps {
	label: string
	id: string
	children?: JSX.Element
	className?: string
}

const styles = {
	label: 'block text-base leading-[150%] font-medium mb-2 dark:text-[#F7F9FB]',
}

export default function InputGroup({
	label,
	id,
	children,
	className = '',
}: InputGroupProps) {
	return (
		<div className={className}>
			<label htmlFor={id} className={`${styles.label}`}>
				{label}
			</label>
			{children && (
				<div>
					{React.cloneElement(children, {
						id,
					})}
				</div>
			)}
		</div>
	)
}
